import React, { useEffect, useRef } from "react";
import "./Privacy.scss";
import DynamicHeader from "../../Header/DynamicHeader";

const DeleteAccount = () => {
  const SUPPORT_EMAIL =
    process.env.REACT_APP_SUPPORT_EMAIL || "support@cvanto.com";

  const PUBLIC_BASE_URL =
    process.env.REACT_APP_PUBLIC_BASE_URL || "https://cvanto.com";

  const rootRef = useRef(null);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, []);

  useEffect(() => {
    const rootEl = rootRef.current;
    if (!rootEl) return;

    const items = Array.from(rootEl.querySelectorAll(".js-reveal"));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            observer.unobserve(e.target);
          }
        });
      },
      {
        root: null,
        rootMargin: "0px 0px -10% 0px",
        threshold: 0.1,
      }
    );

    items.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <DynamicHeader
        title="Видалення акаунта"
        variant="glass"
        size="regular"
        showBack
        withSpacer
      />

      <div className="legal legal--privacy" ref={rootRef}>
        <header className="legal__hero js-reveal">
          <div className="legal__hero-body">
            <h1 className="legal__title">Як видалити акаунт Cvanto</h1>

            <p className="legal__subtitle">
              Платформа: <u>{PUBLIC_BASE_URL}</u>
            </p>

            <p className="legal__subtitle">
              URL сторінки:{" "}
              <a href={`${PUBLIC_BASE_URL}/delete-account`}>
                {PUBLIC_BASE_URL}/delete-account
              </a>
            </p>

            <p className="legal__subtitle">
              Останнє оновлення: <b>24 червня 2026 року</b>
            </p>
          </div>
        </header>

        <section className="legal__section js-reveal">
          <h2>1. Як видалити акаунт у застосунку</h2>

          <p>
            Користувач Cvanto може самостійно надіслати запит на видалення
            свого акаунта безпосередньо в застосунку.
          </p>

          <ol>
            <li>Відкрийте застосунок Cvanto.</li>
            <li>Увійдіть у свій акаунт.</li>
            <li>Перейдіть у профіль.</li>
            <li>Відкрийте налаштування акаунта.</li>
            <li>Натисніть “Видалити акаунт”.</li>
            <li>Підтвердьте видалення акаунта.</li>
          </ol>
        </section>

        <section className="legal__section js-reveal">
          <h2>2. Які дані видаляються</h2>

          <p>
            Після видалення акаунта Cvanto видаляє або анонімізує персональні
            дані, пов’язані з акаунтом користувача, зокрема:
          </p>

          <ul>
            <li>профіль користувача;</li>
            <li>ім’я користувача;</li>
            <li>email або інші дані входу;</li>
            <li>аватар і публічний опис профілю;</li>
            <li>оголошення користувача;</li>
            <li>пости, сторіс та інший створений контент;</li>
            <li>збережені елементи, підписки та налаштування акаунта.</li>
          </ul>
        </section>

        <section className="legal__section js-reveal">
          <h2>3. Дані, які можуть зберігатися тимчасово</h2>

          <p>
            Деякі дані можуть зберігатися протягом обмеженого часу, якщо це
            потрібно для безпеки, запобігання шахрайству, виконання юридичних
            обов’язків або розгляду скарг.
          </p>

          <p>До таких даних можуть належати:</p>

          <ul>
            <li>журнали безпеки;</li>
            <li>технічні записи про дії в акаунті;</li>
            <li>дані, пов’язані зі скаргами або порушеннями правил;</li>
            <li>резервні копії, які можуть зберігатися до 30 днів.</li>
          </ul>
        </section>

        <section className="legal__section js-reveal">
          <h2>4. Запит на видалення через підтримку</h2>

          <p>
            Якщо ви не маєте доступу до свого акаунта або не можете видалити
            його через застосунок, напишіть нам на{" "}
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
          </p>

          <p>
            У листі вкажіть email або ім’я користувача, пов’язане з акаунтом,
            щоб ми могли знайти його та обробити запит.
          </p>
        </section>

        <section className="legal__section js-reveal">
          <h2>5. Строк обробки запиту</h2>

          <p>
            Ми намагаємося обробляти запити на видалення акаунта якомога
            швидше. У більшості випадків видалення або анонімізація даних
            виконується протягом 30 днів після отримання або підтвердження
            запиту.
          </p>
        </section>

        <section className="legal__section js-reveal">
          <h2>6. Контакти</h2>

          <p>
            З питань видалення акаунта або персональних даних звертайтесь на:{" "}
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
          </p>
        </section>
      </div>
    </>
  );
};

export default DeleteAccount;